
gsap.registerPlugin(ScrollTrigger);
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollToPlugin)
import { ScrollToPlugin } from "gsap/all";

import menuAnim from "./menu-anim";
import partnersAnim from "./partners";
import creationsAnim from "./creations";
import accordion from "./accordion";
import scrollTop from "./scrolltop";
import headerArrow from "./headerarrow";
import homeAnim from "./home";
import actuAnim from "./actualites";
import ateliersAnim from "./ateliers";

menuAnim.init();
partnersAnim.init();
scrollTop.init();

let homepage = document.querySelector('#homepage');
if(homepage !== null){
  homeAnim.init();
}
let ateliers = document.querySelector('#ateliers');
if(ateliers !== null){
  ateliersAnim.init();
}


let actu = document.querySelector('#actualites');
if(actu !== null){
  actuAnim.init();
}


let projectCard = document.querySelectorAll('project-card');
if(projectCard !== null){
  creationsAnim.init();
}

let headerbtn = document.querySelector(".downarrow");
if(headerbtn !== null){
  headerArrow.init();
}

let accordionSection = document.querySelector('.accordion');
if(accordionSection !== null) {
  accordion.init();
}

